import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "meetOwner"
const MeetOwnerIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M6 14.25C6.678 14.25 7.25 14.7 7.436 15.318L8.781 14.646C9.301 14.386 9.876 14.25 10.458 14.25H12C13.35 14.25 14.492 15.142 14.868 16.369L17.903 14.662C18.938 14.08 20.248 14.394 20.906 15.382 21.524 16.31 21.378 17.547 20.562 18.305L17.918 20.761C16.714 21.878 15.131 22.5 13.488 22.5H12.566C11.614 22.5 10.668 22.346 9.765 22.045L7.472 21.28C7.341 21.976 6.732 22.5 6 22.5H4.5C3.672 22.5 3 21.828 3 21V15.75C3 14.922 3.672 14.25 4.5 14.25zM4.5 21H6V15.75H4.5zM10.458 15.75C10.11 15.75 9.764 15.831 9.452 15.987L7.5 16.963V19.709L10.239 20.623C10.989 20.872 11.775 21 12.566 21H13.488C14.753 21 15.97 20.521 16.897 19.661L19.541 17.206C19.818 16.95 19.868 16.53 19.658 16.214 19.435 15.88 18.99 15.772 18.638 15.97L15.19 17.91C14.21 18.46 13.106 18.75 11.983 18.75H11.625C11.211 18.75 10.875 18.414 10.875 18S11.211 17.25 11.625 17.25H11.983C12.493 17.25 12.997 17.17 13.48 17.02 13.37 16.3 12.75 15.75 12 15.75z"
            clipRule="evenodd"
          />
          <path d="M18 6C18.828 6 19.5 6.672 19.5 7.5S18.828 9 18 9 16.5 8.328 16.5 7.5 17.172 6 18 6" />
          <path
            fillRule="evenodd"
            d="M16.5 2.25C19.4 2.25 21.75 4.6 21.75 7.5S19.4 12.75 16.5 12.75C14.716 12.75 13.141 11.86 12.193 10.5H4.548L2.834 8.467C2.364 7.908 2.364 7.092 2.834 6.533L4.548 4.5H12.193C13.14 3.14 14.716 2.25 16.5 2.25M16.5 3.75C14.963 3.75 13.642 4.676 13.063 6H5.246L3.98 7.5 5.246 9H7.5V7.5H9V9H10.5V7.5H12V9H13.063C13.642 10.324 14.963 11.25 16.5 11.25 18.571 11.25 20.25 9.571 20.25 7.5S18.571 3.75 16.5 3.75"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default MeetOwnerIcon
